// 获取当前用户信息
export const GET_CURRENT_USER_INFO = 'GET_CURRENT_USER_INFO';
export const GET_CURRENT_USER_INFO_SUCCESS = 'GET_CURRENT_USER_INFO_SUCCESS';
export const GET_CURRENT_USER_INFO_ERROR = 'GET_CURRENT_USER_INFO_ERROR';
